export default __webpack_public_path__ + "static/media/080_finish_good.1435939f.mp4";